import { useState, useEffect } from "react";
import "./NewsBlock.css";

export default function NewsBlock() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/data/news.json");
        if (!response.ok) throw new Error("Fehler beim Laden der News");
        const data = await response.json();
        const sortedNews = data.sort((a, b) => a.order - b.order);
        setNewsData(sortedNews);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) return <section className="news-block"><p>News laden...</p></section>;
  if (error) return <section className="news-block"><p>Fehler: {error}</p></section>;

  const recentNews = newsData.slice(0, 2);

  return (
    <section className="news-block">
      <h2 className="news-title">Latest News</h2>
      <div className="news-container">
        {recentNews.map((news) => (
          <article key={news.id} className="news-item">
            <h3 className="news-item-title">{news.title}</h3>
            <p className="news-item-date">{news.date}</p>
            <p className="news-item-content">{news.content}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
